


















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class AlatBantu extends Vue {
  @Prop() setAlatBantu: string;
  @Prop() setLabel!: string;
  // validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  // get alergi() {
  label = "";
  placeholder = this.setLabel;
  //   return this.setAlergi;
  // }
  // set alergi(value) {
  //   this.$emit("alergi", value);
  // }
  @Watch("setAlatBantu")
  changeAlergi(v) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("alatbantu", v);
    // console.log(v);
    this.setAlatBantu = v;
  }
}
